var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M16.6589 134.653L0.525728 85L16.6589 35.3473L58.896 4.66025L111.104 4.66024L153.341 35.3473L169.474 85L153.341 134.653L111.104 165.34L58.896 165.34L16.6589 134.653Z",
    stroke: "#313F38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5168 69.2754C90.5168 69.2754 91.7238 73.9019 95.3446 77.8676C98.9653 81.8332 105 85.1379 105 85.1379C105 85.1379 98.9653 88.4425 95.3446 92.4082C91.7238 96.3738 90.5168 101 90.5168 101",
    stroke: "#313F38",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.3448,
    y: 85.4901,
    width: 0.689671,
    height: 37.932,
    transform: "rotate(-90 65.3448 85.4901)",
    fill: "#313F38",
    stroke: "#313F38",
    strokeWidth: 0.689671
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/nextBtn.c594e2c7ae836cf6ed8fa13b887cb3ac.svg";
export { ForwardRef as ReactComponent };